<div class="trade_layout_wrap">
  <app-header-trade></app-header-trade>
  <main class="trade_layout_main">
    <div class="trade-layout">
      <!-- Top Ticker Bar -->
      <app-option-ticker></app-option-ticker>

      <!-- Main Grid -->
      <div class="main-content">

        <!-- Left: Expiry Filter -->
        <div class="left-panel-wrapper">
          <app-option-expiry></app-option-expiry>
        </div>

        <!-- Center: Chart & Chain -->
        <div class="center-panel-wrapper">
          <app-option-chart *ngIf="viewMode === 'CHART'"></app-option-chart>
          <app-option-chain *ngIf="viewMode === 'TABLE'"></app-option-chain>
        </div>

        <!-- Right: Order Entry -->
        <div class="right-panel-wrapper" *ngIf="hasSelectedContract">
          <app-option-order-place></app-option-order-place>
        </div>

      </div>

      <!-- Bottom: History -->
      <div class="bottom-panel-wrapper">
        <app-option-history></app-option-history>
      </div>

    </div>
  </main>
</div>